import FullScreenVideo from 'views/pages/activities/show/types/video/fullScreenVideo/FullScreenVideo';

export default class VideoActivity extends BaseView {

    initialize() {

        Backbone.View.Components.fullscreen.open(
            FullScreenVideo, {
                model: this.model.task_groups.at(0),
                title: this.model.getLabel().title
            }
        );

        this.listenToOnce(
            Backbone.View.Components.fullscreen,
            'modalClosed',
            this.destroy
        );
    }

    onDestroy() {
        Backbone.history.navigate(
            '/sections/show/' + this.model.get('section_id'), {
                trigger: true
            }
        );
    }

}
